import bannerDataMapper from "@/mappers/bannerDataMapper";
import {
    useBanner,
    useBannerActions,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useEffect, useMemo } from "react";

const useGetBanner = () => {
    const { data: banner } = useBanner();
    const { refreshBanner } = useBannerActions();

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState !== "visible") {
                return;
            }

            refreshBanner();
        };

        // `visibilitychange` ne couvre que l'onglet caché, pas le retour sur la fenêtre.
        const handleWindowFocus = () => refreshBanner();

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("focus", handleWindowFocus);

        return () => {
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange,
            );
            window.removeEventListener("focus", handleWindowFocus);
        };
    }, [refreshBanner]);

    const data = useMemo(
        () => (banner ? bannerDataMapper(banner) : null),
        [banner],
    );

    return { data };
};

export default useGetBanner;
